export const endpoints = {
  production: {
    basket: 'https://basket-api.notonthehighstreet.com',
    favourites: 'https://user-list.notonthehighstreet.com',
    communicationPreference: 'https://communication-preferences.notonthehighstreet.com/anonymous',
  },
  staging: {
    basket: 'https://basket-api.public.b.stag-eu-west-1.noths.com',
    favourites: 'https://user-list.public.b.stag-eu-west-1.noths.com',
    communicationPreference:
      'https://communication-preferences.public.b.stag-eu-west-1.noths.com/anonymous',
  },
  oldstaging: {
    basket: 'https://basket-api.public.b.prod-eu-west-1.noths.com',
    favourites: 'https://user-list.public.b.prod-eu-west-1.noths.com',
    communicationPreference:
      'https://communication-preferences.public.b.prod-eu-west-1.noths.com/anonymous',
  },
  qa: {
    basket: 'https://basket-api-shared.qa.noths.com',
    favourites: 'https://user-list.public.shared.qa.noths.com',
    communicationPreference: 'https://communication-preferences.qa.noths.com/anonymous',
  },
  development: {
    basket: 'https://basket-api-shared.qa.noths.com',
    favourites: 'https://user-list.public.shared.qa.noths.com',
    communicationPreference: 'https://communication-preferences.qa.noths.com/anonymous',
  },
};
